import { Component, OnInit, Input, ViewChild, OnDestroy, HostBinding } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { saveAs } from 'file-saver';
import { EventServicesService } from 'src/app/services/event-services.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { MenuItem, MessageService } from 'primeng/api';
import { BreadcrumbService  } from 'xng-breadcrumb';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { nanoid } from 'nanoid'
import { candidateStatus, statusColorMapping} from 'src/app/enum/candidate-status.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { WorkflowComponent } from '../workflow/workflow.component';
import { AppService } from 'src/app/services/app.service';
import { ViewPreferencesCacheService, ViewPreferences } from 'src/app/services/view-preferences-cache.service';
import { Subscription } from 'rxjs';
import { FormBuilderService } from 'src/app/services/form-builder.service';
import { FieldLookupService } from 'src/app/services/field-lookup.service';
import { firstValueFrom } from 'rxjs';
import { MultiSelectFilterEvent } from 'primeng/multiselect';
import { FilterState } from 'src/app/shared/states/filter-state';
import { SettingsService } from 'src/app/services/settings.service';

export enum CandidateStatus {
  applied = 'Applied',
  pending = 'Pending',
  selected = 'Selected',
  rejected = 'Rejected',
  archived = 'Archived',
  shortlisted = 'Shortlisted',
  addedToVettedPool = 'Added To Vetted Pool',
  submitted = 'Submitted',
  scheduled = 'Scheduled',
  allClear = 'All Clear',
  eligible = 'Eligible',
  attended = 'Attended',
  noteligible = 'Not Eligible',
  waitlisted = 'Waitlisted',
  noShow = 'No Show',
  slotSend = 'Slot Sent',
  submittedPartially = 'Submitted Partially',
  submissionPending = 'Submission Pending',
  partiallyApproved = 'Partially Approved',
  joiningConfirmed = 'Joining Confirmed',
  joined = 'Joined',
  notJoining = 'Not Joining',
  notJoined = 'Not Joined',
  yetToJoin = 'Yet To Join',
  mailPending = 'Mail Pending',
  offered = 'Offered',
  offerPending = 'Offer Pending',
  offerRevision = 'Offer Revision',
  offerAccepted = 'Offer Accepted',
  offerDeclined = 'Offer Declined',
  onHold = 'On Hold',
  futureCandidate = 'Future Candidate',
}

interface BulkUploadError {
  error_file?: string;
  detail?: string;
  force_submit?: boolean;
}

interface FilterCriteria {
  filterField: string,
  filterValue: string | string[] | null
}

interface CandidateFilters {
  gender: any;
  degree: any[];
  specialization: any[];
  collegeName: any[];
  jobRole: any[];
  stage: any;
  status: any;
  alignmentCategory: any;
  candidate_source_id: any[];
}
@Component({
    selector: 'app-candidate-list',
    templateUrl: './candidate-list.component.html',
    styleUrls: ['./candidate-list.component.css'],
    standalone: false
})
export class CandidateListComponent implements OnInit, OnDestroy {
  unsub$: Subject<void> = new Subject<void>();

  @ViewChild(WorkflowComponent) workflowComponent!: WorkflowComponent;
  private routerSubscription: any;
  // Booloan Var
  displayOverview: boolean = false;
  displayCandidates: boolean = true;
  displayJobDetails: boolean = false;
  displayWorkflow: boolean = false;
  displayInterview: boolean = false;
  loadingSpinner: boolean = false;
  showSettingsSidebar: boolean = false;
  showDownloadSidebar: boolean = false;
  displaySaveFilterSettings: boolean = false;
  displaySaveColumnSettings: boolean = false;
  displayUserDetails: boolean = false;
  isInEvent!: boolean;
  showBulkUpload: boolean = false;
  sendingInvite: boolean = false;
  clicked: boolean = false;
  uploadingFile: boolean = false;
  bulkFile: boolean = false;
  insideSearch: boolean = false;
  cohortUploaded: boolean = false;

  // Array Var
  candidateList: any = [];
  usersCol: Array<any> = [];
  searchEmailIds: Array<any> = [];
  _usersCol: Array<any> = [];
  _selectedColumns: Array<any> = [];
  colsToDownload: Array<any> = [];
  pageLimits: Array<any> = [];
  checkedColumns: Array<any> = [];
  columnsToSave: Array<any> = [];
  savedColumnSettings: Array<any> = [];
  selectedCandidates: Array<any> = [];
  selectedUser: Array<any> = [];
  candidateStatus: any = {}
  breadcrumbs: MenuItem[] = [];
  // statusColor: Array<any> = [];
  excel: File[] = [];
  stageDetails: Array<any> = [];
  emailPattern: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/;
  dateFormat: any;
  timeFormat: any;
  searchPayload: any;


  loadSingleInvite: boolean = false;
  loadExistingUser: boolean = false;
  userExist: boolean = false;
  countDiv: boolean = false;
  eventList: any = [];
  sourceTypeList: any = [];
  sourceNameList: any = [];
  existingUserList: any = [];
  existingUserColumns: any = []
  requiredColumns: Array<any> = [];
  existingRequiredColumns: Array<any> = [];
  errorFileData: any;
  errorFile: any;
  templateValue: Array<any> = [];
  counts: any;
  acknowledgeUsers: any;
  bulkAcknowledgeUsers: any = [];
  bulkValidatedData: any = [];
  existingUsers: any;
  mediaFile: File[] = [];
  loadEventList: boolean = false;
  allCategoryEvents: any;
  disableInvite: boolean = false;
  bulkEnable: boolean = false;
  fileMessage: any;
  uploadedFileName: any;
  cohortFileSize: any;
  skeletonData: any[] = Array(10).fill({}).map((_, index) => ({
    id: `skeleton-${index}`,
    name: '',
    stage_name: '',
    status: '',
    stage: '',
    email: '',
    mobile_number: '',
    gender: '',
    dob: '',
    created_at: '',
    college_names: ''
  }));
  

  // Number Var
  first: number = 1;
  last: number = 10;
  pageSize: number = 10;
  pageNumber: number = 1;
  totalLength: number = 0;
  numberOfStages: number = 0;
  totalPages: number = 1;

  // String Var
  columnSearchTerm: string = '';
  filterSearchTerm: string = '';
  downloadSearchTerm: string = '';
  downloadAs: string = 'excel';
  exportName: string = 'userList';
  selectedJobId: string = '';
  selectedEventId: string = '';
  bulkUpload!: MenuItem[];
  _selectedCategory: string = 'single-invite';
  // eventRadio: string = 'technical';
  userPrivileges: Set<string> = new Set();
  selectedJobName: string = '';
  schoolId: string = '';
  selectedEventName: string = '';
  schoolData: any;
  schoolCode: string = '';
  inviteUrl: string = ''
  eventId: string = '';
  eventName: string = '';
  eventCategory: string = '';
  link: string = '';
  category: any = localStorage.getItem("eventCategory");
  companyId: string = '';
  errorFileUrl: string | null = null;
  importSuccess: boolean = false;
  recruiterId: any;
  formId: string = '';
  privilege: any;
  userRole: string = '';
  order_by: string = 'asc';
  sort_by: string = 'candidate_uuid';
  searchText: string = '';
  private searchSubject = new Subject<string>();

  filterCriteria: Array<FilterCriteria> = [];
  filterLoading: boolean = false;
  activeTabIndex: number[] = [0];
  filterFieldVisibility: { [key: string]: boolean } = {};
  filterFieldTypes: { [key: string]: string } = {};
  registrationFormId: string = '';
  registrationFormFields: Array<any> = [];
  genderList: any[] = [];
  collegeList: any[] = [];
  jobRoles: Array<{ label: string; value: string }> = [];
  stageList: Array<{ label: string; value: string }> = [];
  statusList: Array<{ label: string; value: string }> = [];
  alignmentCategoryList: Array<{ label: string; value: string }> = [];
  candidateSourcesList: Array<{ label: string; value: string }> = [];
  instituteList: any[] = [];
  selectedCollegeList: any[] = [];
  degreeList: Array<{ label: string; value: string }> = [];
  specializationList: Array<{ label: string; value: string }> = [];
  
  candidateFilter = new FilterState<CandidateFilters>({
    gender: null,
    degree: [],
    specialization: [],
    collegeName: [],
    jobRole: [],
    stage: null,
    status: null,
    alignmentCategory: null,
    candidate_source_id: [],
  });
  instituteSearch$: Subject<void> = new Subject<void>();
  institutionsPage: number = 1;
  hasMoreInstitutions: boolean = true;
  loadingInstitutions: boolean = false;
  institutionsSearchQuery: string = '';
  private readonly CACHE_ROUTE_KEY = 'candidates-list';
  private cacheSubscription: Subscription = new Subscription();
  private formDataApiCached: boolean = false;


  singleInvite: FormGroup = new FormGroup({
    invites: new FormControl(),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    emailID: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
    source: new FormControl('', Validators.required),
    eventCategory: new FormControl('', Validators.required)
  })

  bulkInviteForm: FormGroup = new FormGroup({
    Bucket_name: new FormControl(''),
    file_name: new FormControl(''),
    link: new FormControl(''),
    source: new FormControl('', Validators.required),
    file: new FormControl(''),
    eventCategory: new FormControl(''),
    actionId: new FormControl('')
  })

  flexBasedUi: boolean = true;
  @HostBinding('class.flex-based') get getFlexBasedUi() {
    return this.flexBasedUi;
  }

  showRegistrationLinkCopyDialog: boolean = false;
  loadingCandidateSources: boolean = false;
  candidateSources: any[] = [];
  selectedCandidateSource = null;

  constructor(
    private jobService: JobServicesService,
    private eventService: EventServicesService,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private fileUploadService: FileUploadService,
    private messageService: MessageService,
    private globalService: GlobalServicesService,
    private appService: AppService,
    private viewPreferencesCache: ViewPreferencesCacheService,
    private formBuilderService: FormBuilderService,
    private fieldLookupService: FieldLookupService,
    private settingsService: SettingsService
    ) {
      this.searchSubject.pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe((value: string) => {
        const trimmedValue = value.trim();
        this.pageNumber = 1;
        if (trimmedValue.length === 0) {
          this.searchEmailIds = [];
          this.searchPayload = {};
          this.getUsers();
        } else if (trimmedValue.length > 2) {
          this.searchEmailIds = trimmedValue.split(' ');
          this.searchPayload = {
            search: this.searchEmailIds
          };
          this.getUsers();
        }
      });
      
    this.pageLimits = [10, 25, 50, 100];

    this.usersCol = [
      { index: 0, field: 'degree_name', header: 'Degree' },
      { index: 1, field: 'degree', header: 'Specialization' },
      { index: 2, field: 'stage_name', header: 'Stage' },
      // { index: 3, field: 'candidate_source', header: 'Source' },
      // { index: 4, field: 'owner', header: 'Owner' },
      { index: 5, field: 'status', header: 'Status', sortable: true },
      // { index: 6, field: 'stage', header: 'STAGE' },
      { index: 7, field: 'email', header: 'E-mail',tooltipField: true, sortable: true },
      { index: 8, field: 'mobile_number', header: 'Contact', sortable: true },
      { index: 9, field: 'candidate_source', header: 'Source' },
      { index: 10, field: 'gender', header: 'Gender', isCapitalize: true },
      { index: 11, field: 'dob', header: 'Date Of Birth' ,sortable: true},
      // { index: 11, field: 'created_at', header: 'Sourced On' },
      { index: 12, field: 'college_names', header: 'Institution',tooltipField: true, sortable: true },
    ]

    this._selectedColumns = [
      { index: 1, field: 'degree', header: 'Specialization' },
      { index: 2, field: 'stage_name', header: 'Stage' },
      { index: 5, field: 'status', header: 'Status', sortable: true },
      // { index: 6, field: 'stage', header: 'STAGE' },
      { index: 7, field: 'email', header: 'E-mail',tooltipField: true, sortable: true },
      { index: 8, field: 'mobile_number', header: 'Contact', sortable: true },
      { index: 9, field: 'candidate_source', header: 'Source' },
      // { index: 10, field: 'gender', header: 'Gender', isCapitalize: true ,sortable: true},
    ]

    this.appService.makeFlexBasedUi.pipe(takeUntil(this.unsub$)).subscribe((res: boolean) => {
      this.flexBasedUi = res;
    })
  }

  columnSettings: FormGroup = new FormGroup({
    name: new FormControl(''),
    saved_columns: new FormControl(this.columnsToSave)
  })


  ngOnInit(): void {
    this.companyId = localStorage.getItem('companyUUID') ?? '';
    this.dateFormat = localStorage.getItem('company-details') 
      ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format 
      : '';
    this.userRole = this.globalService.privilegeRoles;
    
    this.loadCachedPreferences();
    this.globalService.userMeta$.subscribe(meta => {
      if (meta && meta.user_profile) {
        this.recruiterId = meta.user_profile.id || '';
      } else {
        this.recruiterId = '';
      }
    });    if(!this.recruiterId) {
    this.globalService.getUserProfileFastApi().subscribe({
      next: (res: any) => {
        if (res.status === 200 && res.body?.auth_user_details?.id) {
          this.recruiterId = res.body.auth_user_details.id;
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch recruiter ID. Retry again.' });
      }
    });}    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
      this.activatedRoute.params.subscribe(params => {
        const newEventId = params["eventId"]
        const sharedService = this.globalService.getSharedService()
        if (sharedService.getCurrentEventId() !== newEventId) {
          sharedService.resetEventDetails()
          this.formDataApiCached = false;
          this.searchText = '';
          this.searchEmailIds = [];
          this.searchPayload = {};
        }
        this.eventId = newEventId
        this.selectedJobId = params['jobId'] || '';
        this.isInEvent = !!this.eventId;
      const navigation = this._router.getCurrentNavigation();
      const cachedEventData = sharedService.getEventDetails(this.eventId);

      if (cachedEventData && cachedEventData.event_details) {
        this.handleEventDetails(cachedEventData.event_details);
        this.eventName = cachedEventData.event_details.name || "Event";
      } else {
        this.setFormLink();
      }

      this.activatedRoute.queryParams.subscribe(queryParams => {
        const view = queryParams['view'] || (this.isInEvent ? 'overview' : 'candidates');
        if (!queryParams['view']) {
          this._router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { view },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });
          return;
        }
        const allowedViews = ['overview', 'candidate', 'candidates', 'jobDetails', 'eventDetails', 'workflow', 'interview'];
        if (!allowedViews.includes(view)) {
          this._router.navigate(['/error']);
          return;
        }
        if (view !== 'candidates' && view !== 'candidate') {
          this.formDataApiCached = false;
        }    
        if (view === 'candidate' || view === 'candidates') {
          this.getUsers();
        }
        if (this.shouldLoadFormLink(view)) {
          this.setFormLink();
        }       
        this.tabSwitch(view);
      });
    });
    this.singleInvite.controls['eventCategory'].setValue(this.category);
    this.bulkInviteForm.controls['eventCategory'].setValue(this.category);
    this._usersCol = this.usersCol;
    this.colsToDownload = this.usersCol;
    this.checkedColumns = this._selectedColumns;
  
  
    this.bulkUpload = [
      { label: 'Send Invite', command: () => this.bulkUp() }
    ];
  
    this.candidateStatus = candidateStatus;
    this.routeChange();
  }
  shouldLoadFormLink(view: string): boolean {
    return view === "candidates" || view === "candidate"
  }
  public getStatusColor(status: candidateStatus): string {
    return statusColorMapping[status] || 'transparent';
  }
  routeChange = () => {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    this.routerSubscription = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlTree = this._router.parseUrl(event.urlAfterRedirects);
        const view = urlTree.queryParams['view'] || (this.isInEvent ? 'overview' : 'candidates');
        this.tabSwitch(view);
      }
    });
    const snapshot: RouterStateSnapshot = this._router.routerState.snapshot;
    const view = snapshot.root.queryParams['view'] || (this.isInEvent ? 'overview' : 'candidates');
    this.tabSwitch(view);
  };
  onSearchInputChange() {
    this.searchSubject.next(this.searchText);
  }  
  tabSwitch = async (tabView: string) => {
    this.flexBasedUi = false;
    this.displayOverview = false;
    switch (tabView) {
      case 'overview': {
        this.displayCandidates = false;
        this.displayJobDetails = false;
        this.displayWorkflow = false;
        this.displayInterview = false;
        this.displayOverview = true;
        break;
      }
      case 'candidate':
      case 'candidates': {
        if (this.userRole == 'interviewer' || this.userRole == 'evaluator') {
          this._router.navigate(['jobs/candidates/', this.selectedJobName], { queryParams: { view: 'workflow' } })
        } else {
          this.displayCandidates = true;
          this.displayJobDetails = false;
          this.displayWorkflow = false;
          this.displayInterview = false;
        }
        break;
      }
      case 'jobDetails':
      case 'eventDetails': {
        if (this.userRole == 'interviewer' || this.userRole == 'evaluator') {
          this._router.navigate(['jobs/candidates/', this.selectedJobName], { queryParams: { view: 'workflow' } })
        } else {
          this.displayCandidates = false;
          this.displayJobDetails = true;
          this.displayWorkflow = false;
          this.displayInterview = false;
        }
        break;
      };
      case 'workflow': {
        this.displayCandidates = false;
        this.displayJobDetails = false;
        this.displayWorkflow = true;
        this.displayInterview = false;
        this.flexBasedUi = true;
        break;
      }
      case 'interview': {
        if (this.userRole == 'evaluator') {
          this._router.navigate(['jobs/candidates/', this.selectedJobName], { queryParams: { view: 'workflow' } })
        } else {
          this.displayCandidates = false;
          this.displayJobDetails = false;
          this.displayWorkflow = false;
          this.displayInterview = true;
        }
        break;
      }
      default:
      {
        this._router.navigate(['/error']);
      }
    }
    this.updateBreadcrumb();
  }
  updateBreadcrumb(): void {
    this.breadcrumbService.set('@eventDetails', this.eventName || 'Event Details');
  }  
  onAddStageClick() {
    if (this.workflowComponent) {
      this.workflowComponent.onClickAddStage();
    }
  }
  // API Functions
  getUsers = () => {
    this.loadingSpinner = true;
    this.candidateList = [];
    let payload: any = {
      eventId: this.eventId,
      page: this.pageNumber,
      size: this.pageSize,
      order_by: this.order_by,
      sort_by: this.sort_by
    };
    if (this.searchPayload?.search && this.searchPayload.search.length > 0) {
      payload['s'] = this.searchPayload.search.join(' ');
    }
    
    this.buildFilterCriteria();
    if (this.filterCriteria.length > 0) {
      payload.filterCriteria = JSON.parse(JSON.stringify(this.filterCriteria));
    }
    
    this.jobService.getCandidatesFastApi(payload.eventId, payload.page, payload.size, payload.order_by, payload.sort_by, payload.s, payload.filterCriteria).subscribe({
      next: (result: any) => {
        this.filterLoading = false;
        this.candidateList = result?.body ? result.body?.items : [];
        this.candidateList.forEach((candidate: any) => {
          candidate.id = candidate.candidate_uuid ?? '-';
          candidate._stageId = candidate.stage?.current_stage ?? '-';
          candidate.candidate_source = candidate.candidate_source ?? '-';
          candidate.owner = candidate.owner ? 
            `${candidate.owner.first_name ?? ''} ${candidate.owner.last_name ?? ''}`.trim() || '-' 
            : '-';
            candidate.degree = this.getEducationDisplay(candidate.specializations);
            candidate.degree_name = this.getEducationDisplay(candidate.degrees);
            candidate.college_names = this.getCollegeDisplay(candidate.college_names);
            candidate.dob = candidate.dob ? candidate.dob : '-';
        });
        this.numberOfStages = this.candidateList.length > 0 ? this.candidateList[0].stage.total_stage : 0;
        this.totalLength = result.body.total || 0;
        this.first = result.body.page || 1;
        this.last = result.body.pages || 10;
        this.pageSize = result.body.size || 10;
        this.totalPages = result.body.pages || 1;
        this.loadingSpinner = false;
      },
      error: () => {
        this.loadingSpinner = false;
        this.filterLoading = false;
      }
    });
  }

hasValidPhoto(candidate: any): boolean {
  return candidate?.photo && candidate.photo.trim() !== '';
}

onImageError(event: any, candidate: any): void {
  event.target.style.display = 'none';
  const initialsElement = event.target.nextElementSibling;
  if (initialsElement) {
    initialsElement.style.display = 'flex';
  }
}

onImageLoad(event: any): void {
  const initialsElement = event.target.nextElementSibling;
  if (initialsElement) {
    initialsElement.style.display = 'none';
  }
}

  private getEducationDisplay(specializations: any): string {
    if (!specializations || typeof specializations !== 'object') {
      return '-';
    }
    if (specializations.pg && specializations.pg.trim() !== '') {
      return this.formatEducation(specializations.pg);
    }
    
    if (specializations.ug && specializations.ug.trim() !== '') {
      return this.formatEducation(specializations.ug);
    }
    
    if (specializations.diploma && specializations.diploma.trim() !== '') {
      return this.formatEducation(specializations.diploma);
    }
    return '-';
  }
  private getCollegeDisplay(collegeNames: any): string {
    if (!collegeNames || typeof collegeNames !== 'object') {
      return '-';
    }
    if (collegeNames.pg && collegeNames.pg.trim() !== '') {
      return collegeNames.pg;
    }
    
    if (collegeNames.ug && collegeNames.ug.trim() !== '') {
      return collegeNames.ug;
    }
    
    if (collegeNames.diploma && collegeNames.diploma.trim() !== '') {
      return collegeNames.diploma;
    }
    
    return '-';
  }
  private formatEducation(education: string): string {
    if (!education) return '-';

    if (!/^[a-z0-9_ ]+$/.test(education)) {
      return education;
    }

    return education
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  getUsersByLimit = () => {
    this.candidateFilter.closeFilter();
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.pageNumber = 1;
    this.first = 1;
    this.last = this.pageSize < this.totalLength ? this.pageSize : this.totalLength;
    
    this.saveCurrentPreferences();
    
    this.getUsers();
  };

  showUserDetails = (user: any, openTab?: string) => {
    this.selectedUser = user;
    this.displayUserDetails = true;
    // Store the tab to open when the sidebar loads
    if (openTab) {
      (this.selectedUser as any).openTab = openTab;
    }
  }
  setFormLink() {
    const sharedService = this.globalService.getSharedService();
    const cachedEventData = sharedService.getEventDetails(this.eventId);
  
    if (cachedEventData && cachedEventData.event_details) {
      this.handleEventDetails(cachedEventData.event_details);
      this.eventName = cachedEventData.event_details.name || "Event";
      return;
    }  
    const request = sharedService.initiateEventDetailsRequest(
      this.eventId, 
      () => this.eventService.getSpecificEventFastApi(this.eventId)
    );
  
    if (!request) {
      this._router.navigate(["/error"]);
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Failed to initiate event details request",
      });
      return;
    }
  
    request.subscribe({
      next: (response: any) => {
        const fullEventData = response?.body;
        const eventDetails = fullEventData?.event_details;
        if (!eventDetails) {
          this._router.navigate(["/error"]);
          return;
        }
  
        if (!sharedService.isEventDetailsLoaded(this.eventId)) {
          sharedService.setEventDetails(this.eventId, fullEventData);
        }
  
        this.handleEventDetails(eventDetails);
        this.eventName = eventDetails.name || "Event";
      },
      error: () => {
        this._router.navigate(["/error"]);
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Error fetching event details",
        });
      },
    });
  }
  
  handleEventDetails(eventDetails: any) {
    this.formId = eventDetails.form.uuid
    this.inviteUrl = `${window.location.protocol}//${window.location.hostname}/form/registration?eventId=${this.eventId}&formId=${this.formId}`
    this.eventName = eventDetails.name || "Event"
    this.updateBreadcrumb()
    this.link = `${this.inviteUrl}`
  }

  candidateSearch(event?: any) {
    this.loadingSpinner = true;
    this.searchEmailIds = (event.target.value).split(' ');
    this.searchPayload = {
      'search': this.searchEmailIds
    }
    this.getUsers();
  }


  sidebarClose() {
    this.singleInvite.reset();
    this.bulkInviteForm.reset();
    this.clicked = false;
    this.sendingInvite = false;
    this.cohortUploaded = false;
    this.uploadedFileName = '';
    this.cohortFileSize = '';
    this.excel = [];
    this.bulkFile = false;
    this.loadSingleInvite = false;
    this.countDiv = false;
    this.bulkEnable = false;
    this.importSuccess = false;
    this.errorFileUrl = '';
    this.showBulkUpload = false;
  }

  bulkSelected() {
    if (this._selectedCategory === 'bulk-invite') {
      this.clicked = false;
      if (this.excel.length == 0) {
        this.bulkFile = true;
      } else {
        this.bulkFile = false;
      }
    } else if (this._selectedCategory === 'single-invite') {
      this.clicked = false;
      this.bulkFile = false;
    }
  }

  sendInvite() {
    this.loadSingleInvite = true;
    this.errorFileUrl = null;
    if (this.cohortUploaded) {
      let payload = {
        file_name: this.uploadedFileName,
        recruiter_id: this.recruiterId
      }
      this.eventService.bulkInviteFastApi(payload, this.eventId).subscribe({
        next: (response: any) => {
          this.loadSingleInvite = false;
          this.importSuccess = true;
          this.errorFileUrl = null;
          this.uploadedFileName = '';
          this.cohortFileSize = '';
          this.cohortUploaded = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail
          });
          setTimeout(() => {
            this.showBulkUpload = false;
          }, 1000);
        },
        error: (error: HttpErrorResponse) => {
          this.loadSingleInvite = false;
          this.uploadedFileName = '';
          this.importSuccess = false;
          this.cohortFileSize = '';
          this.cohortUploaded = false;
          const errorResponse = error.error as BulkUploadError;
  
          if (errorResponse.error_file) {
            this.errorFileUrl = errorResponse.error_file;
            this.messageService.add({
              severity: 'warn',
              summary: 'Warning',
              detail: 'Some records have errors. Please check the error report.'
            });
            return;
          }
  
          if (errorResponse.detail === "File not found") {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'File not found. Please try uploading again.'
            });
            return;
          }
          if (error.status === 500) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Upload data in the provided sample format.'
            });
            return;
          }
  
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorResponse.detail || 'Something went wrong.'
          });
        }
      });
    }
    else {
      this.loadSingleInvite = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please upload a file to proceed!' });
    }
  }

  downloadErrorReport() {
    if (this.errorFileUrl) {
      window.open(this.errorFileUrl, '_blank');
    }
  }

  fileUpload(event: any) {
    const file = event.addedFiles[0];
    this.errorFileUrl = '';
    if (file.size > 2 * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'File size should be less than 2MB'
      });
      return;
    }
    this.cohortFileSize = `${(file.size / 1024).toFixed(2)} KB`;
    const fileName = this.generateFileName(file);
    const filePath = `temp/${this.companyId}/${fileName}`;

    const payload = {
      file_path: filePath,
      bucket_type: 'private',
      origin:"invite_candidate"
    };

    this.uploadingFile = true;
    this.fileUploadService.getSignedUrlGCS(payload).subscribe({
      next: (response: any) => {
        if (response && response.body.signed_url) {
          this.uploadFileToGCS(response.body.signed_url, file, filePath, fileName);
          
        }
      },
      error: (error) => {
        console.error('Error getting signed URL:', error);
        this.uploadingFile = false;
      }
    });
  }

  private generateFileName(file: any): string {
    let fileName = file.name.split(".");
    let fileExtension = fileName.pop();
    const timestamp = new Date().getTime();
    return `${fileName.join().replace(/\s/g, "").replace(/[^\w\s]/gi, '')}_${timestamp}.${fileExtension}`;
  }

  uploadFileToGCS(signedUrl: string, file: any, filePath: string, filename: string) {
    this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
      next: (response: any) => {
        if (response && response.status === "success") {
          this.uploadingFile = false;
          this.uploadedFileName = filename;
          this.cohortUploaded = true;
        }
      },
      error: (error) => {
        console.error('Error uploading file to GCS:', error);
        this.uploadingFile = false;
      }
    });
  }

  saveColumnSettings = () => {
    this.loadingSpinner = true;
    this.columnsToSave = this.checkedColumns.map(e => e.field);

    this.columnSettings.setValue({
      name: this.columnSettings.get("name")?.value,
      saved_columns: this.columnsToSave
    });

    this.eventService.saveUserPreferencesFastApi(this.columnSettings.value, 'event_candidate').subscribe({
      next: (result: any) => {
        this.getSavedColumns();
        this.loadingSpinner = false;
        this.columnSettings.reset();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: result.body.detail,
        });
        this.clearColumnPreferenceName();
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
    this.clearColumnPreferenceName();
  }

  getSavedColumns = () => {
    this.eventService.getUserPreferencesFastApi('event_candidate').subscribe(res => {
      this.savedColumnSettings = res.body.user_preferences ? res.body.user_preferences : []
    });
  }

  deleteSavedColumns = (columnId: string) => {
    this.loadingSpinner = true;
    this.eventService.deleteUserPreferencesFastApi(columnId).subscribe({
      next: res => {
      this.getSavedColumns();
      this.loadingSpinner = false;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.body.detail,
      });
    },
    error: () => {
      this.loadingSpinner = false; // Handle error case
    }
  });
  }
  // Normal Functions
  addCandidateForm = () => {
    window.open(this.inviteUrl);
  }


  applySelectedColumns = () => {
    this.checkedColumns = this.checkedColumnsBackup;
    this._selectedColumns = this.sortedColumns();
    this.showSettingsSidebar = false;
  }

  download() {
    window.open('assets/Book1.xlsx', 'Download');
  }

  bulkUp() {
    this.showBulkUpload = true;
    // this._selectedCategory = 'single-invite';
    // this.singleInvite.controls['eventCategory'].setValue(this.category);
    this.bulkInviteForm.controls['eventCategory'].setValue(this.category);
  }

  onRemoveExcel() {
    this.cohortUploaded = false;
    this.countDiv = false;
    this.bulkEnable = false;
    this.counts = 0;
    this.bulkAcknowledgeUsers = [];
    this.existingUsers = [];
    this.bulkValidatedData = [];
    this.acknowledgeUsers = [];
    this.uploadedFileName = '';
    this.importSuccess = false;
  }

  errorReportDownload() {
    window.open(this.errorFile, '_blank')
  }

  private sortedColumns(): any[] {
    return this.checkedColumns.sort((a, b) => (a.index < b.index) ? -1 : 1);
  }

  clearSelectedColumns = () => {
    this.checkedColumns = [];
  }

  showSaveColumnSettings = () => {
    this.columnsToSave = this.checkedColumnsBackup.map(e => e.field);
    this.displaySaveColumnSettings = true;
  }

  searchColumns = (searchTerm: string) => {
    if (this.showSettingsSidebar) {
      this._usersCol = this.usersCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    if (this.showDownloadSidebar) {
      this.colsToDownload = this.usersCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }
  }

  applySavedSettings = (savedColumnValue: Array<any>) => {
    this.checkedColumnsBackup = this._usersCol.filter(e => savedColumnValue.includes(e.field));
    this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
  }

  showOverview = async () => {
    if (this.isInEvent)
      await this._router.navigate(['events/', this.eventId], { queryParams: { view: 'overview' } });
    else
      await this._router.navigate(['jobs/', this.selectedJobId], { queryParams: { view: 'overview' } });
    this.routeChange();
  }

  showCandidates = async () => {
    if (this.isInEvent)
      await this._router.navigate(['events/', this.eventId], { queryParams: { view: 'candidates' } });
    else
      await this._router.navigate(['jobs/', this.selectedJobId], { queryParams: { view: 'candidates' } });
    this.routeChange();
  }

  showJobDetails = async () => {    
    if (this.isInEvent) 
      await this._router.navigate(['events/', this.eventId], { queryParams: { view: 'eventDetails' } });
    else 
      await this._router.navigate(['jobs/', this.selectedJobId], { queryParams: { view: 'jobDetails' } });
    this.routeChange();
  }  

  showWorkflow = async () => {        
    if (this.isInEvent) await this._router.navigate(['events/', this.eventId], { queryParams: { view: 'workflow' } })
    else await this._router.navigate(['jobs/', this.selectedJobId], { queryParams: { view: 'workflow' } })
    this.routeChange();
  }

  showInterview = async () => {
    if (this.isInEvent) await this._router.navigate(['events/', this.eventId], { queryParams: { view: 'interview' } })
    else await this._router.navigate(['jobs/', this.selectedJobId], { queryParams: { view: 'interview' } })
    this.routeChange();
  }
  onSelectedCandidateChange= (value: []) => {
    this.selectedCandidates = value;
  };

  openEditCandidateDetails() {
    if (this.selectedCandidates.length !== 1) return;

    const candidate = this.selectedCandidates[0];
    const candidateUuid = candidate.candidate_uuid || candidate.id;
    const registrationId = candidate.registration_id;

    if (!registrationId || !this.formId || !candidateUuid || candidateUuid === '-') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Cannot edit: missing registration data or form configuration.'
      });
      return;
    }

    const editUrl = `${window.location.protocol}//${window.location.hostname}/form/registration?eventId=${this.eventId}&formId=${this.formId}&editMode=true&registrationId=${registrationId}&candidateId=${candidateUuid}`;
    window.open(editUrl, '_blank');
    this.selectedCandidates = [];
    this.checkedColumns = [];
  }

  exportCandidate = (type: string) => {
    let checkedColumnFields: any = ['name', 'id'];
    this.checkedColumns.forEach((each) => {
      checkedColumnFields.push(each.field);
    });
    let afterFilter: any = [];
    const dataToExport = this.selectedCandidates.length > 0 ? this.selectedCandidates : this.candidateList;
    dataToExport.forEach((eachData: any) => {
      let filterData: any = {};
      checkedColumnFields.forEach((item: any) => {
        if (item === 'stage') {
          filterData['total_stage'] = eachData.stage?.total_stage ?? '-';
          filterData['current_stage'] = eachData.stage?.current_stage ?? '-';
        } else {
          eachData.hasOwnProperty(item) && (filterData[item] = eachData[item]);
        }
      });
      if (
        checkedColumnFields.find((element: string) => element === 'location')
      ) {
        let locationString: string = '';
        eachData.locationInformation.forEach((eachlocation: any) => {
          locationString +=
            `${locationString.length ? ', ' : ''}` + eachlocation.location;
        });
        filterData['location'] = locationString;
      }
      afterFilter.push(filterData);
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(afterFilter);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: type === 'excel' ? 'xlsx' : 'csv', type: 'array' });
      this.saveAsExcelFile(excelBuffer, this.exportName, type);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string, type: string): void {
    let FILE_TYPE =
      type === 'excel'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        : 'text/csv';
    let FILE_EXTENSION = type === 'excel' ? '.xlsx' : '.csv';
    const data: Blob = new Blob([buffer], {
      type: FILE_TYPE,
    });
    saveAs(data, fileName + '_export_' + new Date().getTime() + FILE_EXTENSION);
    this.showDownloadSidebar = false;
    this.resetCheckedColumnsToDefault();
  }

  sampleData() {
    this.eventService.bulkInviteFileDownloadFastApi().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          const blob = new Blob([res.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const contentDisposition = res.headers.get('content-disposition');
          let filename = 'bulk_invite_data.xlsx';
          if (contentDisposition) {
            const matches = contentDisposition.match(/filename="(.+)"/);
            if (matches?.[1]) {
              filename = matches[1];
            }
          }
          saveAs(blob, filename);
        }
      },
      error: (err) => {
        console.error('Error downloading the file:', err);
      }
    });

  }

  // Pagination
  next(): void {
    this.candidateFilter.closeFilter();
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.first = this.first + this.pageSize;
    this.last = this.last + this.pageSize < this.totalLength ? this.pageSize + this.last : this.totalLength;
    this.pageNumber += 1;
    
    this.saveCurrentPreferences();
    
    this.getUsers();
  }

  prev(): void {
    this.candidateFilter.closeFilter();
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.first = this.first - this.pageSize;
    this.last = this.last - this.pageSize > this.pageSize ? (this.last == this.totalLength ? this.totalLength - this.candidateList.length : this.last - this.pageSize) : this.pageSize;
    this.pageNumber -= 1;
    
    this.saveCurrentPreferences();
    
    this.getUsers();
  }

  isLastPage(): boolean {
    return !this.totalPages || this.pageNumber === this.totalPages;
  }

  isFirstPage(): boolean {
    return this.first > 1 ? false : true;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.usersCol.filter(col => val.includes(col));
  }

  getArray(num: number) {
    return new Array(num);
  }


  onKeyPress(event: KeyboardEvent, user: any) {
    if (event.key === 'Enter' || event.key === ' ') {
        this.showUserDetails(user);
    }
}
onClickSettingsSidebar(): void {
  this.showSettingsSidebar = true;
  this.candidateFilter.closeFilter();
  this.showDownloadSidebar = false;
  this.getSavedColumns();
}
statusFilter: string = 'All';
selectAllColumns: boolean = false;

// Copy functionality (same as role-list)
copyToClipboard(text: string, label: string): void {
  if (!text) return;
  
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text.toString()).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied!',
        detail: `${label} copied to clipboard`,
        life: 2000
      });
    }).catch((err) => {
      console.error('Clipboard API failed:', err);
      this.fallbackCopyToClipboard(text.toString(), label);
    });
  } else {
    this.fallbackCopyToClipboard(text.toString(), label);
  }
}

private fallbackCopyToClipboard(text: string, label: string): void {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied!',
        detail: `${label} copied to clipboard`,
        life: 2000
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Copy Failed',
        detail: 'Please copy manually: ' + text,
        life: 3000
      });
    }
  } catch (err) {
    console.error('Fallback copy failed:', err);
    this.messageService.add({
      severity: 'error',
      summary: 'Copy Failed',
      detail: 'Please copy manually: ' + text,
      life: 3000
    });
  } finally {
    document.body.removeChild(textArea);
  }
}

setStatusFilter(status: string) {
  this.statusFilter = status;
}


toggleSelectAll() {
  if (this.selectAllColumns) {
    this.checkedColumns = [...this.colsToDownload];
  } else {
    this.checkedColumns = [...this._selectedColumns];
  }
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}

onColumnCheckChange() {
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}
// Add these methods to your component

getInitials(fullName: string): string {
  if (!fullName) return 'UN';
  
  const names = fullName.trim().split(' ');
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }
  
  const firstInitial = names[0].charAt(0).toUpperCase();
  const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
  return firstInitial + lastInitial;
}

getAvatarColor(name: string): string {
  // Better color palette matching the image style
  const colors = [
    '#FF6B35', // Orange-red
    '#4ECDC4', // Teal
    '#45B7D1', // Sky blue
    '#96CEB4', // Mint green
    '#FECA57', // Yellow
    '#FF9FF3', // Pink
    '#54A0FF', // Blue
    '#5F27CD', // Purple
    '#00D2D3', // Cyan
    '#FF9F43', // Orange
    '#EE5A24', // Red-orange
    '#009432', // Green
    '#0652DD', // Dark blue
    '#9980FA', // Light purple
    '#833471', // Dark purple
    '#F79F1F', // Amber
    '#A3CB38', // Lime
    '#1289A7', // Dark teal
    '#D63031', // Red
    '#74B9FF'  // Light blue
  ];
  
  if (!name) return colors[0];
  
  // Simple hash function for consistent color assignment
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  return colors[Math.abs(hash) % colors.length];
}
copyRegistrationLink(): void {
  if (!this.inviteUrl) return;

  this.showRegistrationLinkCopyDialog = true;

  this.selectedCandidateSource = null;
  this.loadingCandidateSources = true;
  this.settingsService.getCandidateSourceNameFastApi().subscribe((res) => {
    this.candidateSources = res?.body?.items || [];
    this.loadingCandidateSources = false;
  }, (err) => {
    this.loadingCandidateSources = false;
  })
}

get copyableRegistrationLink(): string {
  return this.inviteUrl + '&source=' + this.selectedCandidateSource;
}

copyRegistrationLinkWithUtm() {
  this.copyToClipboard(this.copyableRegistrationLink, 'Registration Link');
  this.showRegistrationLinkCopyDialog = false;
}

goToSources() {
  this._router.navigate(['/settings'], {
    queryParams: { menu: 'configuration' }
  });
}

getTruncatedId(fullId: string): string {
  if (!fullId) return '';
  
  if (fullId.length <= 13) {
    return fullId;
  }
  
  return fullId.substring(0, 13) + '...';
}

resetCheckedColumnsToDefault(): void {
  this.checkedColumns = [...this._selectedColumns];
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}
clearColumnPreferenceName(): void {
  this.columnSettings.get('name')?.setValue('');
}

getAlignmentClass(alignmentCategory: string): string {
  if (!alignmentCategory) return 'alignment-neutral';
  
  switch (alignmentCategory.toLowerCase()) {
    case 'high':
      return 'alignment-high';
    case 'medium':
      return 'alignment-medium';
    case 'low':
      return 'alignment-low';
    case 'insufficient data':
      return 'alignment-insufficient';
    default:
      return 'alignment-neutral';
  }
}


private loadCachedPreferences(): void {
  const defaultPreferences: ViewPreferences = {
    pageSize: 10,
    pageNumber: 1,
    statusFilter: 'All',
    searchTerm: '',
    sortBy: 'candidate_uuid',
    orderBy: 'asc',
    selectedColumns: this._selectedColumns
  };

  const cachedPreferences = this.viewPreferencesCache.getPreferencesWithDefaults(
    this.CACHE_ROUTE_KEY, 
    defaultPreferences
  );

  if (cachedPreferences) {
    this.pageSize = cachedPreferences.pageSize || 10;
    this.pageNumber = cachedPreferences.pageNumber || 1;
    this.statusFilter = cachedPreferences.statusFilter || 'All';
    this.sort_by = cachedPreferences.sortBy || 'candidate_uuid';
    this.order_by = cachedPreferences.orderBy || 'asc';
    this.searchText = '';
    
    if (cachedPreferences.selectedColumns && cachedPreferences.selectedColumns.length > 0) {
      this._selectedColumns = cachedPreferences.selectedColumns;
      this.checkedColumns = [...this._selectedColumns];
    }

    // Update pagination display
    this.first = ((this.pageNumber - 1) * this.pageSize) + 1;
    this.last = Math.min(this.pageNumber * this.pageSize, this.totalLength);
  } else {
    // If no cache exists (e.g., after refresh), use defaults
    this.pageSize = 10;
    this.pageNumber = 1;
    this.statusFilter = 'All';
    this.searchText = '';
    this.first = 1;
    this.last = this.pageSize;
  }
}


private saveCurrentPreferences(): void {
  const preferences: ViewPreferences = {
    pageSize: this.pageSize,
    pageNumber: this.pageNumber,
    statusFilter: this.statusFilter,
    searchTerm: '',
    sortBy: this.sort_by,
    orderBy: this.order_by,
    selectedColumns: this._selectedColumns
  };

  this.viewPreferencesCache.savePreferences(this.CACHE_ROUTE_KEY, preferences);
}

refreshTable(): void {
  this.viewPreferencesCache.clearCacheOnRefresh();
  
  this.pageSize = 10;
  this.pageNumber = 1;
  this.statusFilter = 'All';
  this.searchText = '';
  this.first = 1;
  this.last = this.pageSize;
  this.formDataApiCached = false;
  this.getUsers();
}

ngOnDestroy(): void {
  this.saveCurrentPreferences();
  this.formDataApiCached = false;
  this.cacheSubscription.unsubscribe();
  this.instituteSearch$.next();
  this.instituteSearch$.complete();
  this.unsub$.next();
  this.unsub$.complete();
}
filterShow() {
  if (!this.formDataApiCached) {
    this.loadDynamicFilterFields();
  }
  this.candidateFilter.openFilter();
  this.hasMoreInstitutions = true;
  // this.collegeList = [...this.selectedCollegeList];
  this.institutionsPage = 1;
}

async loadDynamicFilterFields() {
  try {
    const sharedService = this.globalService.getSharedService();
    let eventDetails = sharedService.getEventDetails(this.eventId);
    
    if (!eventDetails?.event_details?.form?.uuid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'No registration form found for this event. Using default filter options.'
      });
      return;
    }

    this.registrationFormId = eventDetails.event_details.form.uuid;

    const formResponse = await firstValueFrom(
      sharedService.initiateFormRequest(this.eventId, () => 
        this.formBuilderService.getFormFastApi(this.registrationFormId)
      ) || this.formBuilderService.getFormFastApi(this.registrationFormId)
    );

    if (formResponse?.body?.form_fields) {
      this.registrationFormFields = this.extractFormFields(formResponse.body.form_fields);

      this.mapDefaultFiltersToFormFields();
      const [formDataResponse] = await Promise.all([
        firstValueFrom(
          this.eventService.getEventFormDataWithQueryFastApi(this.eventId, 'stage,status,alignment_category,candidate_source')
        ),
        this.loadFormDataWithFields(formResponse.body.form_fields),
      ]);
      
      if (formDataResponse?.body) {
        if (formDataResponse.body.stages && Array.isArray(formDataResponse.body.stages)) {
          this.stageList = formDataResponse.body.stages.map((stage: any) => ({
            label: stage.name || stage,
            value: stage.uuid || stage
          }));
        }
        
        if (formDataResponse.body.statuses && Array.isArray(formDataResponse.body.statuses)) {
          this.statusList = formDataResponse.body.statuses.map((status: any) => ({
            label: status.name || status,
            value: status.name || status
          }));
        }
        
        if (formDataResponse.body.alignment_categories && Array.isArray(formDataResponse.body.alignment_categories)) {
          this.alignmentCategoryList = formDataResponse.body.alignment_categories.map((category: any) => ({
            label: category || category,
            value: category || category
          }));
        }
        
        if (formDataResponse.body.candidate_sources && Array.isArray(formDataResponse.body.candidate_sources)) {
          this.candidateSourcesList = formDataResponse.body.candidate_sources.map((source: any) => ({
            label: source.name,
            value: source.id
          }));
        }
      }

      this.formDataApiCached = true;
    } else {
      await this.loadFormDataFallback();
      this.formDataApiCached = true;
    }
    
  } catch (error) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to load filter options. Using default options.'
    });
  }
}

async loadFormDataWithFields(formFields: any[]) {
  try {
    const sharedService = this.globalService.getSharedService();
    const fieldNames = this.registrationFormFields.map((f: any) => f.name.toLowerCase());
    const hasCollegeFields = fieldNames.some((name: string) => 
      name.includes('ug_college') || name.includes('pg_college') || 
      name.includes('diploma_college') || name.includes('college_name') || name.includes('institute')
    );
    const hasDegreeFields = fieldNames.some((name: string) =>
      ['ug_degree', 'pg_degree', 'diploma_degree'].includes(name)
    );
    const hasSpecializationFields = fieldNames.some((name: string) =>
      name.includes('specialization') || name.includes('branch')
    );
    
    const lookupFlags = {
      includeRoles: true,
      includeInstitutes: hasCollegeFields,
      includeEducationDegrees: hasDegreeFields,
      includeEducationBranches: hasSpecializationFields,
      includeCertifications: false,
      includeLanguages: false,
      includeSkills: false,
      includeSscBoards: false,
      includeIntermediateBoards: false,
      includeEntranceTests: false
    };
    
    const response = await firstValueFrom(
      sharedService.initiateFormDetailsRequest(this.eventId, () => 
        this.formBuilderService.getEventSpecificFormDetailsFastApi(this.eventId, lookupFlags)
      ) || this.formBuilderService.getEventSpecificFormDetailsFastApi(this.eventId, lookupFlags)
    );

    const apiData = response?.body || response;
    
    if (apiData?.roles && Array.isArray(apiData.roles) && apiData.roles.length > 0) {
      this.jobRoles = apiData.roles.map((role: any) => ({
        label: role.job_role_name,
        value: String(role.job_role_id)
      }));
    }
    
    if (hasCollegeFields && apiData?.institutes) {
      const institutes = Array.isArray(apiData.institutes) ? apiData.institutes : (apiData.institutes.items || []);
      this.instituteList = institutes;
      this.updateCollegeList();
    }
    

    const withoutOthers = (list: any[]) =>
      list.filter((item: any) => String(item?.name ?? '').toLowerCase() !== 'others')
          .map((item: any) => ({ label: item.name, value: item.name }));

    if (apiData?.education_degrees?.length) {
      this.degreeList = withoutOthers(apiData.education_degrees);
    }
    if (apiData?.education_branches?.length) {
      this.specializationList = withoutOthers(apiData.education_branches);
    }
    
    formFields.forEach((section: any) => {
      if (section.section_form_fields) {
        section.section_form_fields.forEach((field: any) => {
          if (field.element_type === 'field') {
            this.processFieldForFilters(field);
          } else if (field.element_type === 'group' && field.form_fields) {
            field.form_fields.forEach((groupField: any) => {
              this.processFieldForFilters(groupField);
            });
          }
        });
      }
    });
  } catch (error) {
    console.error('Error loading form data with fields:', error);
  }
}

processFieldForFilters(field: any) {
  const fieldName = field.name.toLowerCase();
  
  if (fieldName === 'gender' && field.options) {
    const existingOptions = this.genderList || [];
    const newOptions = field.options.map((opt: any) => ({
      label: opt.label || opt,
      value: opt.value || opt
    }));
    this.genderList = [...existingOptions, ...newOptions.filter((opt: any) => 
      !existingOptions.some((existing: any) => existing.value === opt.value)
    )];
  }
  
}

async loadFormDataFallback() {
  try {
    const sharedService = this.globalService.getSharedService();
    const lookupFlags = {
      includeRoles: true,
      includeInstitutes: true,
      includeCertifications: false,
      includeLanguages: false,
      includeSkills: false,
      includeSscBoards: false,
      includeIntermediateBoards: false,
      includeEntranceTests: false
    };
    
    const response = await firstValueFrom(
      sharedService.initiateFormDetailsRequest(this.eventId, () => 
        this.formBuilderService.getEventSpecificFormDetailsFastApi(this.eventId, lookupFlags)
      ) || this.formBuilderService.getEventSpecificFormDetailsFastApi(this.eventId, lookupFlags)
    );

    const apiData = response?.body || response;
    
    if (apiData?.roles) {
      this.jobRoles = (apiData.roles || []).map((role: any) => ({
        label: role.job_role_name,
        value: String(role.job_role_id)
      }));
    }
    
    if (apiData?.institutes) {
      this.instituteList = apiData.institutes.items || [];
      this.updateCollegeList();
    }
  } catch (error) {
    console.error('Error loading form data fallback:', error);
  }
}


updateCollegeList() {
  if (this.instituteList && this.instituteList.length > 0) {
    const instituteOptions = this.instituteList.map((institute: any) => ({
      label: `${institute.name}, ${institute.city}, ${institute.state}`,
      value: `${institute.name}, ${institute.city}, ${institute.state}`,
    }));
    this.collegeList = [...this.selectedCollegeList, ...instituteOptions];
  }
}

extractFormFields(formFields: any[]): any[] {
  const extractedFields: any[] = [];
  
  formFields.forEach((section: any) => {
    if (section.section_form_fields) {
      section.section_form_fields.forEach((field: any) => {
        if (field.element_type === 'field') {
          extractedFields.push({
            name: field.name,
            label: field.label || field.name,
            type: field.type,
            options: field.options || [],
            is_required: field.is_required,
            placeholder: field.placeholder,
            section: section.name
          });
        } else if (field.element_type === 'group' && field.form_fields) {
          field.form_fields.forEach((groupField: any) => {
            extractedFields.push({
              name: groupField.name,
              label: groupField.label || groupField.name,
              type: groupField.type,
              options: groupField.options || [],
              is_required: groupField.is_required,
              placeholder: groupField.placeholder,
              section: section.name,
              group: field.name
            });
          });
        }
      });
    }
  });

  return extractedFields;
}

mapDefaultFiltersToFormFields() {
  this.filterFieldVisibility = {
    gender: false,
    degree: false,
    specialization: false,
    collegeName: false,
    jobRole: false,
    stage: true,
    status: true,
    alignmentCategory: true,
    candidate_sources: true
  };
  
  this.filterFieldTypes = {
    gender: 'dropdown',
    degree: 'dropdown',
    specialization: 'dropdown',
    collegeName: 'dropdown',
    jobRole: 'dropdown',
    stage: 'dropdown',
    status: 'dropdown',
    alignmentCategory: 'dropdown'
  };

  this.registrationFormFields.forEach((field: any) => {
    const fieldName = field.name.toLowerCase();
    
    if (fieldName === 'gender') {
      this.filterFieldVisibility['gender'] = true;
      if (field.type === 'input' || field.type === 'Input') {
        this.filterFieldTypes['gender'] = 'input';
      }
      if (field.options && field.options.length > 0) {
        this.setFieldOptions(field, 'genderList');
      }
    }
    
    if (['ug_degree', 'pg_degree', 'diploma_degree'].includes(fieldName)) {
      this.filterFieldVisibility['degree'] = true;
      if (field.type === 'input' || field.type === 'Input') {
        this.filterFieldTypes['degree'] = 'input';
      }
    }

    if (['ug_specialization', 'pg_specialization', 'diploma_specialization'].includes(fieldName)) {
      this.filterFieldVisibility['specialization'] = true;
      if (field.type === 'input' || field.type === 'Input') {
        this.filterFieldTypes['specialization'] = 'input';
      }
    }

    if (fieldName.includes('ug_college') || fieldName.includes('pg_college') || 
        fieldName.includes('diploma_college') || fieldName === 'college_name') {
      this.filterFieldVisibility['collegeName'] = true;
      if (field.type === 'input' || field.type === 'Input') {
        this.filterFieldTypes['collegeName'] = 'input';
      }
    }
    
    if (fieldName === 'preferred_role' || fieldName === 'job_role') {
      this.filterFieldVisibility['jobRole'] = true;
      if (field.type === 'input' || field.type === 'Input') {
        this.filterFieldTypes['jobRole'] = 'input';
      }
    }
  });
  
  this.setDefaultFilterOptions();
}

setFieldOptions(field: any, filterListName: string) {
  const appendToFilterList = (targetList: any[], newOptions: any[]) => {
    if (!newOptions || newOptions.length === 0) return targetList;
    
    const existingOptions = targetList || [];
    const validNewOptions = newOptions.filter((option: any) => 
      option && option.label && option.label.trim() !== '' && 
      option.value && option.value.trim() !== '' &&
      !existingOptions.some((existing: any) => existing.value === option.value)
    );
    
    return [...existingOptions, ...validNewOptions];
  };

  switch (filterListName) {
    case 'genderList':
      if (field.options && field.options.length > 0) {
        this.genderList = appendToFilterList(this.genderList, field.options.map((opt: any) => ({
          label: opt.label || opt,
          value: opt.value || opt
        })));
      }
      break;
    
    default:
      break;
  }
}

setDefaultFilterOptions() {
  if (!this.genderList || this.genderList.length === 0) {
    this.genderList = [
      { label: "Male", value: "male" },
      { label: "Female", value: "female" },
      { label: "Prefer not to say", value: "others" }
    ];
  }
}

filterUpdate(filterValue: any, filterField: string) {
  let finalFilterValue = filterValue;
  
  if (typeof filterValue === 'string' && filterValue.trim() === '') {
    finalFilterValue = null;
  }
  
  if (Array.isArray(filterValue) && filterValue.length === 0) {
    finalFilterValue = [];
  }

  if(filterField === "candidate_source_id" && !finalFilterValue) {
    finalFilterValue = [];
  }

  this.candidateFilter.updateDraft({ [filterField]: finalFilterValue } as Partial<CandidateFilters>);

  if (filterField === "collegeName" && Array.isArray(filterValue)) {
    const foundColleges = filterValue
      .map((val: any) => this.collegeList.find((college: any) => college.value === val))
      .filter(Boolean);
    
    this.selectedCollegeList = [
      ...this.selectedCollegeList,
      ...foundColleges.filter(
        (newItem: any) => !this.selectedCollegeList.some(c => c?.value === newItem?.value)
      )
    ];
  }
}

filterHide() {
  this.filterLoading = false;
  this.candidateFilter.closeFilter();
}

closeFilter(event: any) {
  if (!event) {
    this.candidateFilter.closeFilter();
  }
}

applySelectedFilter = () => {
  this.filterLoading = true;
  this.candidateFilter.apply();
  this.pageNumber = 1;
  this.first = 1;
  this.buildFilterCriteria();
  this.getUsers();
};

clearSelectedFilters = () => {
  this.filterLoading = false;
  this.candidateFilter.reset();
  this.filterCriteria = [];
  this.selectedCollegeList = [];
  this.activeTabIndex = [0];
  this.getUsers();
};

cancelFilter(): void {
  this.candidateFilter.cancel();
}

buildFilterCriteria() {
  const applied = this.candidateFilter.applied;
  this.filterCriteria = [];
  
  const fieldMapping: { [key: string]: string } = {
    'status': 'jobStatus',
    'gender': 'gender',
    'collegeName': 'collegeName',
    'degree': 'degree',
    'specialization': 'specialization',
    'jobRole': 'jobRole',
    'stage': 'stage',
    'alignmentCategory': 'alignmentCategory'
  };

  Object.keys(applied).forEach((key: string) => {
    const value = (applied as any)[key];
    if (value !== null && value !== '' && !(Array.isArray(value) && value.length === 0)) {
      const mappedField = fieldMapping[key] || key;
      this.filterCriteria.push({ filterField: mappedField, filterValue: value });
    }
  });
}

filterInstitute(event: MultiSelectFilterEvent) {
  if (event.filter.length >= 2 || !event.filter.length) {
    this.instituteSearch$.next();
    this.institutionsSearchQuery = event.filter;
    this.hasMoreInstitutions = true;
    this.collegeList = [...this.selectedCollegeList];
    this.institutionsPage = 1;
    this.getInstitutions();
  }
}

getInstitutions() {
  this.loadingInstitutions = true;
  const params: any = { page: this.institutionsPage, s: this.institutionsSearchQuery };
  if (!this.institutionsSearchQuery) {
    delete params.s;
  }

  this.formBuilderService.getEventSpecificFormDetailsFastApi(this.eventId, { includeInstitutes: true }, params)
    .pipe(takeUntil(this.instituteSearch$))
    .subscribe((res) => {
      const institutions = res.body.institutes;
      let items: any[] = institutions.items || [];

      if (items) {
        if (items.length) {
          items = items.filter((item) => 
            item.name?.toLowerCase() !== "others" && 
            item.state?.toLowerCase() !== "others" && 
            item.city?.toLowerCase() !== "others"
          );
          let updatedItems = this.formBuilderService.mapFieldOptions('institute', items, ['name', 'city', 'state'], ['name', 'city', 'state']);
          updatedItems = updatedItems.filter((item) => {
            const exists = (this.collegeList as any[]).some(
              (coll: any) => coll.label === item.label && coll.value === item.value
            );
            return !exists;
          });
          this.collegeList = [...this.collegeList, ...updatedItems];
        }

        if (items.length < institutions.size) {
          this.hasMoreInstitutions = false;
        }
      } else {
        this.hasMoreInstitutions = false;
      }

      this.loadingInstitutions = false;
    }, (err) => {
      this.loadingInstitutions = false;
      this.hasMoreInstitutions = true;
    });
}

onInstitutionDropdownShow(event: any) {
  setTimeout(() => {
    const dropdownPanels = document.querySelectorAll('.p-multiselect-overlay .p-multiselect-list-container');
    dropdownPanels.forEach(panel => {
      panel.addEventListener('scroll', this.handleDropdownScroll.bind(this));
    });
  }, 200);
}

onInstitutionDropdownHide(event: any) {
  const dropdownPanels = document.querySelectorAll('.p-multiselect-overlay .p-multiselect-list-container');
  dropdownPanels.forEach(panel => {
    panel.removeEventListener('scroll', this.handleDropdownScroll.bind(this));
  });
}

handleDropdownScroll(event: any) {
  const element = event.target;
  const threshold = 100;

  if (element.scrollTop + element.clientHeight >= element.scrollHeight - threshold) {
    if (this.hasMoreInstitutions && !this.loadingInstitutions) {
      setTimeout(() => {
        if (this.hasMoreInstitutions && !this.loadingInstitutions) {
          this.institutionsPage++;
          this.getInstitutions();
        }
      }, 300);
    }
  }
}

checkedColumnsFields: string[] = [];
checkedColumnsBackup: any[] = [];
updatedSelectedColFields() {
  this.checkedColumnsBackup = JSON.parse(JSON.stringify(this.checkedColumns));
  this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
}

updateCheckedColumns(event: any) {
  this.checkedColumnsFields = event;
  this.checkedColumnsBackup = this._usersCol.filter((col) => event.includes(col.field))
}
}
